import { useScanDeviceApiUpsert } from '@hooks/api/useScanDeviceApiUpsert';
import type { PhasedRollout } from 'types/api';

export const usePhasedRolloutUpsert = useScanDeviceApiUpsert<
  PhasedRollout,
  Partial<Omit<PhasedRollout, 'id'>>
>('/phased-rollouts');
